<template>
  <div class="picker-row">
    <SlottedRow
      :allow-delete="editing && displayField.allowDelete"
      :handle-delete="handleDelete"
      :uuid="displayField.uuid"
    >
      <template #label>
        <div class="display-field-text picker-row-label">
          {{ displayField.label }}
        </div>
      </template>
      <template
        v-if="displayField.citation"
        #icon
      >
        <CitationIcon
          :display-field="displayField"
        />
      </template>
      <template #value>
        <div
          v-if="!editing || !displayField.allowEdit"
          class="display-field-text picker-row-value"
        >
          {{ displayField.value }}
        </div>
        <v-select
          v-else
          v-model="pick"
          :items="displayField.pickerOptions"
          bg-color="#EBEBEB"
          :data-testid="`picker-row-${displayField.label}`"
          class="display-field-text picker-row-select"
          @update:model-value="checkPick(pick)"
          @update:menu="handleSelectFocus"
        >
          <template #item="data">
            <div
              class="display-field-text picker-row-option"
              v-bind="data.props"
            >
              {{ data.item.title + '&nbsp;' }}
            </div>
          </template>
        </v-select>
      </template>
    </SlottedRow>
  </div>
</template>

<script>
import SlottedRow from './SlottedRow.vue';
import {DisplayField} from '@/lib/classes/InfoWindowContent';
import CitationIcon from '@/components/InfoWindow/DisplayFields/CitationIcon.vue';

export default {
  name: 'PickerRow',
  components: {
    SlottedRow,
    CitationIcon,
  },
  props: {
    displayField: {
      type: DisplayField,
      required: true,
    },
    editing: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['updateDisplayField', 'deleteDisplayField'],
  data() {
    return {
      originalPick: this.displayField.value ?? null,
      pick: this.displayField.value ?? null,
      dropdownExpanded: false,
    };
  },
  methods: {
    handleSelectFocus() {
      this.dropdownExpanded = !this.dropdownExpanded;

      if (!this.dropdownExpanded) {
        document.activeElement.blur();
      }
    },
    checkPick(pick) {
      // Unfocus the v-select dropdown
      document.activeElement.blur();

      // If we selectd the orignal option, do nothing
      if (pick === this.originalPick) return;

      // If we selected a new option, update originalPick and emit event to update the display field
      this.originalPick = pick;

      this.$emit('updateDisplayField', new DisplayField({
        ...this.displayField,
        value: pick,
        pickerOptions: Array.from(this.displayField.pickerOptions),
      }));
    },
    handleDelete() {
      this.$emit('deleteDisplayField', this.displayField);
    },
  },
};
</script>

<style lang="scss" scoped>
.picker-row {
  &-label {
    padding: 0 5px;
  }

  &-value {
    padding: 0 3px;
  }

  &-select {
    :deep(.v-field) {
      font-size: 13px;
      min-height: 23px;
      border-radius: 2px;
    }

    :deep(.v-input__details) {
      display: none
    }

    :deep(.v-field__input) {
      height: 23px;
      min-height: 23px;
      padding-inline-start: 0;
      padding-inline-end: 0;
      padding-top: 0;
      padding-bottom: 0;
      font-size: 13px;
      & input {
        position: absolute;
        right: 5px;
        top: 5px;
        font-size: 13px;
      }
    }

    :deep(.v-field__append-inner) {
      min-height: 23px;

      i {
        position: absolute;
        right: 5px;
        top: 3px;
        transition: none !important;
      }
    }

    :deep(.v-messages) {
      display: none;
    }

    :deep(.v-select__selection-text) {
      @extend .display-field-text;

      position: absolute;
      left: 0px;
      top: 0px;
      padding-left: 6px;
      padding-top: 3px;
      height: 23px;
      width: 100%;
    }

    :deep(.v-field__outline) {
      display: none;
    }
  }

  &-option {
    font-size: 13px;
    cursor: pointer;
    padding-left: 5px;
    width: 100%;

    &:hover {
      background: #EBEBEB;
    }
  }
}
</style>
